"use client";
import {
  BettorBasic,
  BettorPicksMetaData,
  BettorDisplay as CommonBettorDisplay,
} from "common";
import React from "react";
import BettorProfileCard from "./profile-card";
import Link from "next/link";
import Avatar from "../primitives/avatar";
import { createProfileSlug } from "@/utils/url";
import RelativeTime from "../relative-time";
import { useShellContext } from "@/utils/providers/shell";

export default function BettorDisplay({
  bettor,
  dark,
  noCard,
  noLink,
  disableLastPicks,
}: {
  bettor: BettorBasic & BettorPicksMetaData;
  dark?: boolean;
  noCard?: boolean;
  noLink?: boolean;
  disableLastPicks?: boolean;
}) {
  if (noCard) {
    return (
      <BettorDisplayInner
        bettor={bettor}
        dark={dark}
        noLink={noLink}
        disableLastPicks={disableLastPicks}
      />
    );
  } else {
    return <></>;
    //   <BettorProfileCard bettor={bettor}>
    //     <BettorDisplayInner bettor={bettor} dark={dark} noLink={noLink} />
    //   </BettorProfileCard>
    // );
  }
}

function BettorDisplayInner({
  bettor,
  dark,
  noLink,
  disableLastPicks,
}: {
  bettor: BettorBasic & BettorPicksMetaData;
  dark?: boolean;
  noLink?: boolean;
  disableLastPicks?: boolean;
}) {
  const { setShouldScrollToTop } = useShellContext();
  let inactive: boolean = false;
  let showLast: boolean = false;
  if (bettor.activePicks === 0) {
    inactive = true;
    if (bettor.lastPickCreatedAt) {
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
      if (
        new Date(bettor.lastPickCreatedAt).getTime() <= sevenDaysAgo.getTime()
      ) {
        showLast = true;
      }
    }
  }

  const html = (
    <>
      <Avatar size="md" img={bettor.avatarUrl}></Avatar>

      <div className="flex flex-col gap-[2px]">
        <div
          className={`whitespace-nowrap items-center text-body-sm-medium normal-case ${
            dark ? "text-white" : "text-secondary-300"
          }`}
        >
          {bettor.displayName || "Deactivated User"}
        </div>
        {bettor.activePicks > 0 ? (
          <div className="flex items-start gap-[2px] pl-[9px]">
            <svg
              width="7"
              height="6"
              viewBox="0 0 7 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 0.5V5.5H7"
                stroke="url(#paint0_linear_1217_135003)"
                strokeWidth="0.5"
              />
              <defs>
                <linearGradient
                  id="paint0_linear_1217_135003"
                  x1="4"
                  y1="0.5"
                  x2="4"
                  y2="5.5"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#FF0016" />
                  <stop offset="1" stopColor="#FF9900" />
                </linearGradient>
              </defs>
            </svg>
            <div className="active-picks-text text-label-sm-bold whitespace-nowrap normal-case">
              {bettor.activePicks} Active{" "}
              {bettor.activePicks === 1 ? "pick" : "picks"}
            </div>
          </div>
        ) : showLast && !disableLastPicks && bettor.lastPickCreatedAt ? (
          <div className="flex items-start gap-[2px] pl-[9px]">
            <svg
              width="7"
              height="6"
              viewBox="0 0 7 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M1 0.5V5.5H7"
                stroke="var(--secondary-600)"
                strokeWidth="0.5"
              />
            </svg>
            <div className="text-secondary-600 text-label-sm-bold whitespace-nowrap normal-case">
              Last pick{" "}
              <RelativeTime date={bettor.lastPickCreatedAt}></RelativeTime>
            </div>
          </div>
        ) : undefined}
      </div>
    </>
  );

  if (noLink || bettor.id === -1) {
    return <div className="flex items-center gap-2 py-0">{html}</div>;
  } else {
    return (
      <Link
        href={createProfileSlug(bettor.displayName || "deactivated_user")}
        className="flex items-center gap-2 py-0"
        onClick={() => setShouldScrollToTop(true)}
      >
        {html}
      </Link>
    );
  }
}
